import {localizedMessage} from '../message/Message';
import React from 'react';
import root from 'window-or-global';

const RedeemSectionLoginRequired = () => {
  const logoutLink = `${root.appContext || ''}/logout?state=${root.location.pathname}`;
  return (
    <>
      <span className="psnWarning">
        {localizedMessage('errors.com.epicgames.posa.psn.login.required')}
      </span>
      <a className="psnWarning psn-sign-out" href={logoutLink}>
        {localizedMessage('epic.code.redemption.common.logout')}
      </a>
    </>
  );
};

export default RedeemSectionLoginRequired;
